import React from 'react'

const Foot = () => {
    return (
        <div className="bg-dark text-white p-5" id="Foot">
            <div className=" foo d-flex justify-content-between border-bottom border-3 pb-5">
            <div className="w-sm-50 mt-5">
                <h3 className="m-5"> SHOPLEFT</h3>
                <p className="lead mt-5">
                Lorem, ipsum dolor sit amet consectetur adipisicing elit. Fugit, distinctio. Repellat reiciendis inventore eaque suscipit nam dolorem quia odit laboriosam quaerat quidem et soluta asperiores enim ipsum fuga, aspernatur fugiat.
                </p>
            </div>
            <div className="socials m-5 w-sm-50 flex-column">
                <h3 className="d-flex m-5 justify-content-center">SOCIALS</h3>
                <div className="d-flex m-5 justify-content-center " >
                    <i className="fa fa-whatsapp fa-3x cials"></i>
                    <i className="fa fa-twitter fa-3x cials"></i>
                    <i className="fa fa-instagram fa-3x cials "></i>
                    <i className="fa fa-facebook fa-3x cials"></i>
                    <i className="fa fa-linkedin fa-3x cials"></i>
                </div>
            </div>
            </div>


            <h2 className="text-center mt-5">Built by Johnson, Goodness</h2>
        </div>
    )
}

export default Foot
